import React, { useContext, useState } from "react";
import "./Home.css";
import Navbar from "../../Components/Navbar/Navbar";
import myContext from "../../Context/Context";
import Footer from "../../Components/Footer/Footer";
import { Link } from "react-router-dom";

function Home() {
  const {apiData,currency} = useContext(myContext);
  const [first_index,setFirst_index]=useState(0);
  const [last_index,setLast_index]=useState(10);
  const[search,setSearch]=useState('');
  const prevIt=()=>{
    if(first_index >0){
      setFirst_index((p)=>p-10);
      setLast_index((n)=>n-10)
    }
  }
  const nextIt=()=>{
    if(last_index<apiData.length){
      setFirst_index((p)=>p+10);
      setLast_index((n)=>n+10)
    }
  }
  
  return (
    <div className="home">
      <Navbar />
      <div className="hero">
        <h1>
          Largest <br /> Crypto Marketplace
        </h1>
        <p>
          Welcome to the world largest cryptocurrency marketplace. Sign up to
          explore more about cryptos.
        </p>
        <form>
          <input type="text" placeholder="Search crypto..." onChange={(e)=>setSearch(e.target.value)}/>
          
        </form>
      </div>
      <div className="crypto-table">
        <div className="table-layout">
          <p className="col-1">#</p>
          <p className="col-4">Coins</p>
          <p className="col-2">Price</p>
          <p className="col-2">24H Change</p>
          <p className="col-3">Market cap</p>
        </div>
        {apiData &&  apiData.filter((item)=>{
          return search===''?item :item.name.toLowerCase().includes(search.toLowerCase())
        }).slice(first_index,last_index).map((data,index) => {
          return (
            <Link to={`/coin/${data.id}`} className="table-layout" key={index}>
              <p className="col-1">{data.market_cap_rank}</p>
              <p className="col-4"><img width="20" src={data.image} alt="coin"/> <span>{data.name}</span></p>
              <p className="col-2">{currency.symbol} {data.current_price}</p>
              <p className={data.price_change_percentage_24h>0?"green col-2":"red col-2"}>{Math.floor(data.price_change_percentage_24h*100)/100}%</p>
              <p className="col-3">{data.market_cap}</p>
            </Link>
          );
        })}
      </div>
      <div className="pagination">
        <button onClick={prevIt}><i className="fa-solid fa-arrow-left"></i> Prev</button>
        <button onClick={nextIt}>Next <i className="fa-solid fa-arrow-right"></i></button>
      </div>
      <div>
      </div>
      <Footer/>
    </div>
  );
}

export default Home;
